// extracted by mini-css-extract-plugin
module.exports = {"templateTitle":"settings_templateTitle__1-fYe","templateCode":"settings_templateCode__c_5lZ","optImgBox":"settings_optImgBox__3R96Q"};